import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm, propTypes, Field } from 'redux-form';
import { TextAreaField } from 'components/FormFields/TextAreaField';
import { Button } from 'components';

@reduxForm({
  form: 'notesForm',
})
export class NotesForm extends React.PureComponent {
  static propTypes = {
    ...propTypes,
    notesPlaceholder: PropTypes.string,
  };

  render() {
    const {
      handleSubmit,
      notesLabel,
      fieldName,
      buttonText = '',
      placeholderSmall = false,
    } = this.props;

    return (
      <form
        onSubmit={handleSubmit}
        className="form-tile-with-image mt-10 flex flex-column align-items-center justify-content-center"
      >
        <Field
          name={fieldName}
          description={notesLabel}
          lightDescription
          fieldClassName={placeholderSmall ? 'placeholder_small' : ''}
          placeholder="Enter text"
          component={TextAreaField}
          maxLength={1000}
        />
        <Button type="submit" className="_red mt-15" style={{ width: '180px' }}>
          {buttonText ? buttonText : 'Request'}
        </Button>
      </form>
    );
  }
}
